document.addEventListener("DOMContentLoaded", function () {
  function startCountdown(countdownContainer, endDate) {
    // Normalize the date to ISO format if it's not already in ISO 8601 format
    const normalizedEndDate = normalizeDate(endDate);
    const countdownEndDate = new Date(normalizedEndDate).getTime();
    
    if (isNaN(countdownEndDate)) {
      console.error("Invalid endDate:", endDate);
      countdownContainer.innerHTML = "<div class='expired'>Invalid Date</div>";
      return;
    }

    const interval = setInterval(function () {
      const now = new Date().getTime();
      const distance = countdownEndDate - now;

      if (distance <= 0) {
        clearInterval(interval);
        countdownContainer.innerHTML = "<div class='expired'>EXPIRED</div>";
      } else {
        const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, "0");
        const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, "0");
        const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
        const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, "0");

        countdownContainer.innerHTML = `
          <div class="countdown-item"><span class="countdown-number">${days}</span><span class="countdown-label">D</span></div><span class="countdown-dots">:</span>
          <div class="countdown-item"><span class="countdown-number">${hours}</span><span class="countdown-label">H</span></div><span class="countdown-dots">:</span>
          <div class="countdown-item"><span class="countdown-number">${minutes}</span><span class="countdown-label">M</span></div><span class="countdown-dots">:</span>
          <div class="countdown-item"><span class="countdown-number">${seconds}</span><span class="countdown-label">S</span></div>
        `;
      }
    }, 1000);
  }

  function normalizeDate(dateString) {
    let normalizedDate = dateString.trim();

    // Ensure the month and day are always two digits
    const parts = normalizedDate.split(' '); // Split date and time
    const dateParts = parts[0].split('-'); // Split date (YYYY-MM-DD)

    // Add leading zeros to month and day if needed
    const month = String(dateParts[1]).padStart(2, '0');
    const day = String(dateParts[2]).padStart(2, '0');

    // Rebuild the date in the correct format: YYYY-MM-DDTHH:mm:ssZ
    normalizedDate = `${dateParts[0]}-${month}-${day}T${parts[1]}Z`; // Convert space to 'T' and append 'Z' for UTC

    return normalizedDate;
  }

  function initializeCountdowns() {
    document.querySelectorAll(".veda-promotional-banner.countdown-timer").forEach((timer) => {
      const countdownContainer = timer.querySelector(".countdown");
      const endDate = timer.getAttribute("data-countdown-end");
      if (endDate && countdownContainer) {
        startCountdown(countdownContainer, endDate);
      }
    });
  }

  // Initialize countdowns when the page loads
  initializeCountdowns();

  // Shopify Customizer Events
  document.addEventListener("shopify:section:load", function () {
    initializeCountdowns(); // Restart countdowns when section loads
  });

  document.addEventListener("shopify:section:unload", function () {
    clearInterval(); // Clear intervals when section is removed
  });
});
